{
  "slug": "iq-distribution",
  "title": "Explication de la distribution IQ",
  "description": "Comment la courbe de cloche, la moyenne, l'écart-type, les queues et les normes réelles se rapportent au QI.",
  "category": "Statistiques de QI",
  "sections": [
    {
      "heading": "Signification",
      "paragraphs": [
        "Comment la courbe de cloche, la moyenne, l'écart-type, les queues et les normes réelles se rapportent au QI.",
        "L'interprétation dépend de la population, de l'instrument, de l'édition, de l'année, de l'échantillonnage, de la langue et de la méthode."
      ]
    },
    {
      "heading": "Lisez les graphiques attentivement",
      "paragraphs": [
        "Vérifiez la représentativité, l’incertitude, les exclusions et si les valeurs ont été mesurées ou estimées.",
        "Les moyennes de groupe se chevauchent considérablement et ne peuvent pas déterminer un individu."
      ]
    },
    {
      "heading": "Une conclusion responsable",
      "paragraphs": [
        "Préférez les ensembles de données primaires et les intervalles transparents. Évitez les affirmations causales fondées uniquement sur la corrélation.",
        "Pour un individu, utilisez les normes d'âge et la documentation technique appropriées."
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "OCDE — Données et méthodologie de PISA",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "Comment la courbe de cloche, la moyenne, l'écart-type, les queues et les normes réelles se rapportent au QI. 18 Juillet 2026."
}
